// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"806a10e4","453":"7551fc76","455":"2a1958b1","821":"b8088cb7","977":"84972552"}[chunkId] + ".chunk.js";
};